import { useEffect, useState } from 'react'

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  )
  useEffect(() => {
    const mq = window.matchMedia(query)
    const on = () => setMatches(mq.matches)
    on()
    mq.addEventListener('change', on)
    return () => mq.removeEventListener('change', on)
  }, [query])
  return matches
}

/** Below 768px the layout transforms — this is the one breakpoint that matters. */
export const useIsMobile = () => useMediaQuery('(max-width: 767px)')
export const useIsCoarse = () => useMediaQuery('(pointer: coarse)')
